import React from 'react';

import StyledLogo from './StyledLogo';
import A from './A';

function Logo () {
  return (
    <StyledLogo>
      <A target="_blank" href="https://www.flamingmachine.ru/">
        Made with ❤ by <span style={{ fontFamily: 'Montserrat', fontSize: '20px' }}>FLAMINGMACHINE</span>
      </A>
    </StyledLogo>
  );
}

export default Logo;
